/**
 * Client surface requesting feature evaluation.
 * Used by future platform-specific resolvers (e.g. mobile-only features).
 */
export enum FeatureClientPlatform {
  WEB_PUBLIC = 'web_public',
  WEB_STUDIO = 'web_studio',
  WEB_ADMIN = 'web_admin',
  MOBILE_CONSUMER = 'mobile_consumer',
  MOBILE_CREATOR = 'mobile_creator',
  API = 'api',
}

/**
 * Subject attributes supplied by callers (API, apps, services).
 * Intentionally uses plain strings for plan/tier IDs so future billing
 * integrations can map without changing this package.
 */
export interface FeatureSubjectContext {
  userId?: string;
  creatorId?: string;
  roles?: string[];
  /** Future: consumer/creator subscription tier from billing. */
  subscriptionTier?: string;
  /** Future: creator plan tier from billing. */
  creatorPlan?: string;
  /** Future: enrolled beta program identifiers. */
  betaPrograms?: string[];
  /** Future: internal staff / dogfood access. */
  isInternal?: boolean;
}

/**
 * Runtime evaluation context passed alongside a feature key.
 * All fields are optional today; resolvers ignore unknown context until implemented.
 */
export interface FeatureEvaluationContext {
  platform?: FeatureClientPlatform;
  subject?: FeatureSubjectContext;
}
